import { SearchResultsListingsGridQuery_searchResults_SearchResults_listings_SearchListing_trackingContext_TrackingContext_distance_TrackingDistance } from '../../contexts/search-results-context/query/__generated__/search-results-listings.fed.query'
import { Distance100 } from '@at/track-types'

export const distance = (
    trackingDistance: SearchResultsListingsGridQuery_searchResults_SearchResults_listings_SearchListing_trackingContext_TrackingContext_distance_TrackingDistance
): Distance100 => {
    return {
        SCHEMA_KEY: 'Distance100',
        distance: trackingDistance.distance,
        distance_unit: trackingDistance.distance_unit || undefined,
    }
}
